import React from 'react';
import styles from './VisuallyHidden.module.scss';

interface VisuallyHiddenProps {
  children: React.ReactNode;
}
export function VisuallyHidden(props: VisuallyHiddenProps): JSX.Element {
  const { children } = props;
  return <span className={styles.container}>{children}</span>;
}
